(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var dir = angular.module('Core');

	/**
	 * Expand or collapse an area
	 * params:
	 * onToggle: function(toggled). Use in your html: on-toggle="fn(toggled)" the function parameter name is important !
	 */
	dir.directive('stlToggler', [function() {

			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				scope: {
					lessTitle: '@',
					moreTitle: '@',
					toggled: '@',
					onToggle: '&'
				},
				templateUrl: 'components/core/toggler/toggler.html',
				link: function(scope) {
					var refresh = function() {
						if (scope.toggled) {
							scope.tTitle = scope.lessTitle;
							scope.intTog = true;
						} else {
							scope.tTitle = scope.moreTitle;
							scope.intTog = false;
						}
					};
					if (scope.toggled === null || scope.toggled === undefined || scope.toggled === '') {
						scope.toggled = false;
					}
					scope.toggled = (typeof scope.toggled).toUpperCase() === 'STRING' ? scope.toggled.toUpperCase() === 'TRUE' : scope.toggled;

					scope.exp = function() {
						if (scope.toggled) {
							scope.toggled = false;
						} else {
							scope.toggled = true;
						}
						refresh();

						if (scope.onToggle !== null) {
							scope.onToggle({
								toggled: scope.toggled
							});
						}
					};

					refresh();
				}
			};
		}]);
})(angular);